import React, { useState, useLayoutEffect } from 'react';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from "@material-ui/core/CssBaseline";
import FormControl from '@material-ui/core/FormControl';
import FormLabel from "@material-ui/core/FormLabel";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";


const useStyles = makeStyles((theme) => ({
    textField: {
      width: '100%',
    },
    selectField: {
      width: '400px',
    },
  }));
  
  const RadioBtnComponent = (props) => {
    const classes = useStyles();
    const [themeType,setThemeType] = useState('dark');
    const [frequency, setFrequency] = React.useState("Once a Day");
    const [freqSelValue, setFreqSelValue] = React.useState('Once a Day');
    
    const handleFreqChange = (event) => {
      setFrequency(event.target.value);
    };
    const handleFreqSelValChange = (event) => {
      setFreqSelValue(event.target.value);
    };
    useLayoutEffect(() => {
        if(props.activeModeClass === "white-content"){  setThemeType("light")}
        else{setThemeType("dark")}
        
      }, []);
      const THEME = createMuiTheme({
        palette: {
          type: themeType,
          primary: {
            main: '#f8955e',
          },
          secondary: {
            main: '#1d8cf8',
          },
        },
      });
      return (
          <div>
              <MuiThemeProvider theme={THEME}>
               <CssBaseline/>   
               <FormControl component="fieldset">
                <FormLabel component="legend">Notification Frequency</FormLabel>
                  <RadioGroup
                    aria-label="frequency"
                    name="frequency"
                    frequency={frequency}
                    onChange={handleFreqChange}
                    
                  >
                    <FormControlLabel
                      value="Once a Day"
                      control={<Radio />}
                      label="Once a Day"
                      onChange={handleFreqSelValChange}
                      checked={freqSelValue === 'Once a Day'}
                    />
                    <FormControlLabel
                      value="Every one hour"
                      control={<Radio />}
                      label="Every one hour"
                      onChange={handleFreqSelValChange}
                      checked={freqSelValue === 'Every one hour'}
                    />
                  </RadioGroup>
                </FormControl>
              </MuiThemeProvider>
          </div>
      )
  }
  export default RadioBtnComponent;